const RENDER_ONLY_PATHS = new Set(["/render/social-post"]);

export const isRenderOnlyPath = (pathname: string): boolean => RENDER_ONLY_PATHS.has(pathname);
